import { HttpEvent, HttpEventType } from "@angular/common/http";
import {
  Component, OnDestroy, OnInit, ViewChild, AfterViewChecked
} from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { AuthService } from "src/app/services/auth/auth.service";
import { UploadService } from "src/app/services/upload/upload.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import { LoginInfo, MultipartUploadProgress, PreSignedUrl, PreSignedUrlModel, SelectedFile, UploadParam, UploadSummaryStatus, multipartMap } from "src/app/shared/models";
import {
  EMEA_CORE_FILE_SIZE,
  UPLOAD_ALERT_FAILED_MSG_1,
  UPLOAD_ALERT_FAILED_MSG_2,
  PREVIOUS_UPLOAD_FAILED_ALERT_MSG_1,
  PREVIOUS_UPLOAD_FAILED_ALERT_MSG_2
} from "src/app/constants";
import { UploadFailurePopupComponent } from '../../pages/upload-failure-popup/upload-failure-popup.component';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.css'],
    standalone: false
})
export class FileUploadComponent implements OnInit, OnDestroy, AfterViewChecked {
  private uploadFailurePopupInitialized = false;
  userVerified = false;
  spinner = false;
  $subscriptions: Subscription[]
  private caseNumber = ''
  isUploading = false
  uploadProgress = 0
  uploadStatus: 'success' | 'failed' | 'presignedUrl_error' | 'cancelled' | null = null
  uploadMessage = ''
  isPMBTACheckON = false;
  loginInfo: LoginInfo | null = null

  multipartUploadModel: MultipartUploadProgress | null
  singleUploadModel: PreSignedUrl | null = null
  payload: UploadParam | null = null
  private $uploadSubscription: Subscription | null = null
  uploadId: string | null = null
  prevUploadData: any;
  unique_id: any;
  failedAtPercentage: number = 0;  
  isMultipartFailed: boolean = false;
  partialParts: boolean = false; // Add this line
  failedParts: boolean = false; // Add this line
  showRadioButton: boolean = false;
  isResumeInitiated: boolean = false;
  radioButtonValue: any;
  uploadProgressBlockElement: any;
  progressMap: any = {};
  batchSize = 5;
  batchPrtnumlist: any[] = [];
  private userId:string = '';
  fileType: string = '';
  FileTypes = {
    ESeries: "eseries",
    ESeriesCore: "eseriesCore",
  };
  overrideUpload: boolean = false;
  panicResult = "";
  panicErrorMessage = "";
  overridePassword: any;
  case_pwd: any;
  case_type: any;
  pmbta_override = "NA";
  ispmbtaUploadBtn = false;
  pmbtaOverridePwdChange = false;
  isBurtAvailable = false;
  public isEseriesUpload: boolean = false;
  osVersion: string = '';
  panicMessage: string = '';

  @ViewChild(UploadFailurePopupComponent) uploadFailurePopup!: UploadFailurePopupComponent;
  showUploadFailurePopup: boolean = false;

  previousUploadCheck: boolean = false; // Add this if not already present
  // Alert messages moved to constants.ts

  constructor(private auth: AuthService, private upload: UploadService, private util: UtilsService) {
    this.$subscriptions = []
    this.multipartUploadModel = null
  }

ngAfterViewChecked() {
  
    if (this.showUploadFailurePopup && this.uploadFailurePopup && !this.uploadFailurePopupInitialized) {
      if (this.previousUploadCheck) {
        this.uploadFailurePopup.uploadAlertMsgFailed = PREVIOUS_UPLOAD_FAILED_ALERT_MSG_1;
        this.uploadFailurePopup.uploadAlertMsg = PREVIOUS_UPLOAD_FAILED_ALERT_MSG_2;
      } else {
        this.uploadFailurePopup.uploadAlertMsgFailed = UPLOAD_ALERT_FAILED_MSG_1;
        this.uploadFailurePopup.uploadAlertMsg = UPLOAD_ALERT_FAILED_MSG_2;
      }
      this.uploadFailurePopupInitialized = true;
    } else if (!this.uploadFailurePopup) {
    }
    // Reset flag if popup is closed
    if (!this.showUploadFailurePopup && this.uploadFailurePopupInitialized) {
      this.uploadFailurePopupInitialized = false;
    }
  }

  ngOnInit() {
    this.$subscriptions.push(
      this.auth.$loginInfo.subscribe({
        next: (user: LoginInfo) => {
          this.loginInfo = user
          this.userVerified = !!user?.allowFileUpload
        }
      })
    )
  }

  get disableFileSelection(): boolean {
    return (
      !this.caseNumber ||
      this.uploadStatus === 'cancelled' ||
      this.showUploadFailurePopup
    );
  }

  whenCasenumberSelect(res: any): void {
    this.caseNumber = res.caseNumber
    this.isEseriesUpload = res.isEseries;
    this.checkForESeries();
    this.uploadStatus = null;
    this.overrideUpload = false;
    this.panicMessage = '';
    this.panicErrorMessage = "";
    this.osVersion = '';
    this.fileType = '';
    this.unique_id = '';
    this.payload = null;
    this.multipartUploadModel = null;
    this.singleUploadModel = null;
    this.overridePassword = null;
    this.ispmbtaUploadBtn = false;
    if (this.isBurtAvailable) {
      this.isBurtAvailable = !this.isBurtAvailable;
      this.setInnerHTML("panicErrorMessage", "");
    }
  }

  whenFileSelect(file: SelectedFile): void {
    this.uploadStatus = null;
    this.uploadProgress = 0;
    this.overrideUpload = false;
    this.isBurtAvailable = false;
    this.overridePassword = null;
    this.ispmbtaUploadBtn = false;
    this.panicMessage = '';
    this.panicErrorMessage = "";
    this.osVersion = '';
    this.fileType = '';
    this.unique_id = '';
    if (!file?.fileName) {
      return
    }
    this.payload = {
      caseNumber: this.caseNumber,
      fileDetails: file,
      loginInfo: this.loginInfo,
      fileType: this.fileType,
      unique_id: this.unique_id,
      fileContentType: file.content.type,
    }
     this.userId = this.loginInfo?.uid || '';
     if (this.checkForESeries()) {
      console.log("Checking for EuroEseries: " + this.fileType,"file.content.size:",file.content.size,"EMEA_CORE_FILE_SIZE:",EMEA_CORE_FILE_SIZE);
      let eseriesFileSize = EMEA_CORE_FILE_SIZE; // 26214400
      if (
        file.content.size >= eseriesFileSize
      ) {
        this.fileType = this.FileTypes.ESeriesCore;
        console.log("Assigning file type for EuroEseries: " + this.fileType);
      }
            this.payload = { ...this.payload, fileType: this.fileType }
            if (file.hasMultiparts) {
              //get previous upload details for multipart upload based it initial upload or resume upload
              this.getPrevUploadDetails(this.payload);
              this.upload.loggingService({
                userName: this.userId,
                caseNumber: this.caseNumber,
                fileName: file.fileName,
                fileSize: file.content.size,
                fileType: this.fileType,
                Message: "Multipart file upload initiated",
                type: "info"
              });
            } else {
              // single file upload
              this.upload.loggingService({
                userName: this.userId,
                caseNumber: this.caseNumber,
                fileName: file.fileName,
                fileSize: file.content.size,
                fileType: this.fileType,
                Message: "Single file upload initiated",
                type: "info"
              });
              this.upload.getSasUrls(this.payload).subscribe({
                next: (sas: PreSignedUrlModel) => {
                  this.upload.loggingService({
                    userName: this.userId,
                    caseNumber: this.caseNumber,
                    fileName: file.fileName,
                    fileType: this.fileType,
                    maskedFileName: sas.preSignedUrls[0].maskedFileName,
                    Message: "Successfully Received Pre-signed url for single file upload",
                    type: "info"
                  });
                  this.singleUploadModel = sas.preSignedUrls[0]
                  this.uploadSingleFile()
                },
                error: (err) => {
                  this.uploadStatus = 'presignedUrl_error';
                  this.upload.$uploadStatus.next({ type: 'presigned_url_error' })
                  this.upload.loggingService({
                    userName: this.userId,
                    caseNumber: this.caseNumber,
                    fileName: file.fileName,
                    fileSize: file.content.size,
                    fileType: this.fileType,
                    Message: "Error while getting Pre-signed url for single file upload",
                    error: JSON.stringify(err),
                    type: "error"
                  });
                }
              })
            }
    }else{
    this.payload ={...this.payload, fileType: this.fileType}
    this.checkUploadFileType(this.payload).subscribe({
      next: (response) => {
        this.fileType = response.fileType;
        if(this.payload){
        this.payload ={...this.payload, fileType: this.fileType}
        if(file.hasMultiparts){
          this.previousUploadCheck = true;
        }
          if (response.fileType == "Core") {
          if(file.hasMultiparts){
            this.getPrevUploadDetails(this.payload);
          }else{
            this.checkForPmbtaMatched(this.payload)
          }

          } else {
            this.payload = { ...this.payload, fileType: this.fileType }
            if (file.hasMultiparts) {
              //get previous upload details for multipart upload based it initial upload or resume upload
              this.getPrevUploadDetails(this.payload);
              this.upload.loggingService({
                userName: this.userId,
                caseNumber: this.caseNumber,
                fileName: file.fileName,
                fileSize: file.content.size,
                fileType: this.fileType,
                Message: "Multipart file upload initiated",
                type: "info"
              });
            } else {
              // single file upload
              this.upload.loggingService({
                userName: this.userId,
                caseNumber: this.caseNumber,
                fileName: file.fileName,
                fileSize: file.content.size,
                fileType: this.fileType,
                Message: "Single file upload initiated",
                type: "info"
              });
              this.upload.getSasUrls(this.payload).subscribe({
                next: (sas: PreSignedUrlModel) => {
                  this.upload.loggingService({
                    userName: this.userId,
                    caseNumber: this.caseNumber,
                    fileName: file.fileName,
                    fileType: this.fileType,
                    maskedFileName: sas.preSignedUrls[0].maskedFileName,
                    Message: "Successfully Received Pre-signed url for single file upload",
                    type: "info"
                  });
                  this.singleUploadModel = sas.preSignedUrls[0]
                  this.uploadSingleFile()
                },
                error: (err) => {
                  this.uploadStatus = 'presignedUrl_error';
                  this.upload.$uploadStatus.next({ type: 'presigned_url_error' })
                  this.upload.loggingService({
                    userName: this.userId,
                    caseNumber: this.caseNumber,
                    fileName: file.fileName,
                    fileSize: file.content.size,
                    fileType: this.fileType,
                    Message: "Error while getting Pre-signed url for single file upload",
                    error: err,
                    type: "error"
                  });
                }
              })
            }
          }
        }
      },
      error: (err) => {
        this.upload.loggingService({
          userName: this.userId,
          caseNumber: this.caseNumber,
          fileName: file.fileName,
          fileSize: file.content.size,
          fileType: this.fileType,
          Message: "Error while checking file type",
          error: JSON.stringify(err), 
          type: "error"
        });
      } 
    });
  }
  }
  private checkForESeries(): boolean {
    console.log("Checking for EuroEseries: " + this.isEseriesUpload);
    if (this.isEseriesUpload) {
      this.fileType = this.FileTypes.ESeries;
      return true;
    }
    return false
  }

  private uploadMultipartsFile() {
    this.singleUploadModel = null;

    if (!this.payload || !this.multipartUploadModel) {
      return
    }
    this.upload.loggingService({ 
      userName: this.userId, 
      caseNumber: this.caseNumber, 
      fileName: this.payload.fileDetails.fileName, 
      maskedFileName:this.multipartUploadModel.multipartSas.maskedFileName,  
      Message: "Entering into uploadMultipartsFile() function", 
      type: "info"
    });
    let poolingReq = {
      unique_id: this.multipartUploadModel.multipartSas.unique_id,
      masked_file_name: this.multipartUploadModel.multipartSas.maskedFileName,
      percentage_done: this.uploadProgress,
    }
    this.multipartUploadModel.paused = false;
    this.upload.poolingService(poolingReq,this.multipartUploadModel).subscribe({
      next: (data) => { let poolingRes = data; },
      error: (err) => {
        this.upload.loggingService({
          userName: this.userId,
          caseNumber: this.caseNumber,
          fileName: this.payload!.fileDetails.fileName,
          maskedFileName: this.multipartUploadModel!.multipartSas.maskedFileName,
          Message: "Error while calling pooling service on upload start",
          error: JSON.stringify(err),
          type: "error"
        });
      }
    });
    this.isUploading = true;
    this.$uploadSubscription = this.upload.uploadMultipartsFile(this.multipartUploadModel, this.payload).subscribe({
      next: () => {
        let percentage = Math.round(
          ((this.multipartUploadModel?.successCount || 0) /
            (this.multipartUploadModel?.totalCount || 1)) *
            100
        );
        this.uploadProgress = Math.min(percentage, 100);
      },
      complete: () => {
        if (this.multipartUploadModel?.allSucceeded()) {
          this.markSuccess(this.multipartUploadModel)
          this.upload.loggingService({ 
            userName: this.userId, 
            caseNumber: this.caseNumber, 
            fileName: this.payload!.fileDetails.fileName, 
            maskedFileName:this.multipartUploadModel.multipartSas.maskedFileName,  
            Message: "Successfully completed multipart file upload", 
            type: "info"
          });
        } else {
          this.isUploading = false;
          this.uploadStatus = 'failed';
          this.uploadMessage = `${this.payload?.fileDetails.fileName} upload failed.`;
          this.partialParts = false;
          this.failedParts = true;
          this.showUploadFailurePopup = true;
          this.upload.$uploadStatus.next({ type: 'upload_failed' })
          this.upload.loggingService({ 
            userName: this.userId, 
            caseNumber: this.caseNumber, 
            fileName: this.payload!.fileDetails.fileName,
            maskedFileName: this.multipartUploadModel?.multipartSas.maskedFileName,
            successParts: this.multipartUploadModel?.successCount,
            totalParts: this.multipartUploadModel?.totalCount,
            Message: `Failed to complete multipart file upload. ${this.multipartUploadModel?.successCount ?? 0}/${this.multipartUploadModel?.totalCount ?? 0} parts uploaded successfully`,
            type: "error"
          });
        }
      },
      error: (err) => {
        this.upload.loggingService({ 
          userName: this.userId, 
          caseNumber: this.caseNumber, 
          fileName: this.payload!.fileDetails.fileName, 
          Message: "Error while uploading file type",
          error: JSON.stringify(err), 
          type: "error"
        });
        this.isUploading = false;
        this.uploadStatus = 'failed';
        this.uploadMessage = `${this.payload?.fileDetails.fileName} upload failed.`;
        this.partialParts = false;
        this.failedParts = true;
        this.showUploadFailurePopup = true;
        this.upload.$uploadStatus.next({ type: 'upload_failed' })
        if (this.payload && this.multipartUploadModel) {
          this.upload.updateMultipartSummary(this.payload, this.multipartUploadModel, UploadSummaryStatus.FAILED);
        }
      }
    })
  }
  private setInnerHTML(id: string, value: string): void {
    const dome = document.getElementById(id)
    if (dome) {
      dome.innerHTML = value ? value : '';
    }
  }
  private markSuccess(sas: MultipartUploadProgress) {
    const param = {
      fileName: this.payload?.fileDetails.fileName,
      caseNumber: this.payload?.caseNumber,
      fileSize: this.payload?.fileDetails.content.size,
      multipartMap: {Parts:sas.uploadedList},
      uploadId:sas.multipartSas.uploadId,
      maskedFileName:sas.multipartSas.maskedFileName,
      fileType: this.payload?.fileType
    }
    this.upload.loggingService({ 
      userName: this.userId, 
      caseNumber: this.caseNumber, 
      fileName: this.payload!.fileDetails.fileName, 
      maskedFileName:this.multipartUploadModel!.multipartSas.maskedFileName,  
      Message: "Entering into completeMultipartUpload() function", 
      type: "info"
    });
    this.upload.markMultipartUploadCompleted(param).subscribe({
      next: () => {
        this.isUploading = false;
        this.uploadProgress = 100
        this.uploadStatus = 'success';
        this.uploadMessage = `${this.payload?.fileDetails.fileName} uploaded successfully.`;
        
        this.upload.$uploadStatus.next({ type: 'upload_success' })
        if (this.payload && this.multipartUploadModel) {
          let poolingReq = {
            unique_id: this.multipartUploadModel.multipartSas.unique_id,
            masked_file_name: this.multipartUploadModel.multipartSas.maskedFileName,
            percentage_done: this.uploadProgress,
          }
          
          this.upload.poolingService(poolingReq,this.multipartUploadModel).subscribe({
            next: (data) => { let poolingRes = data; },
            error: (err) => {
              this.upload.loggingService({
                userName: this.userId,
                caseNumber: this.caseNumber,
                fileName: this.payload!.fileDetails.fileName,
                maskedFileName: this.multipartUploadModel!.multipartSas.maskedFileName,
                Message: "Error while calling pooling service on upload complete",
                error: JSON.stringify(err),
                type: "error"
              });
            }
          });
          
          this.upload.updateMultipartSummary(this.payload, this.multipartUploadModel, UploadSummaryStatus.COMPLETED,this.osVersion,this.panicMessage);
          this.updatingCaseNote(
            this.caseNumber,
            param.fileName,
            param.fileType
          );
          this.upload.loggingService({ 
      userName: this.userId, 
      caseNumber: this.caseNumber, 
      fileName: this.payload!.fileDetails.fileName, 
      maskedFileName:this.multipartUploadModel!.multipartSas.maskedFileName,  
      Message: "Multipart file upload completed successfully", 
      type: "info"
    });
    this.caseNumber = '';
    this.osVersion = '';
    this.panicMessage = '';
    this.fileType = '';
    this.unique_id = '';
     this.payload = null;
     this.multipartUploadModel = null;
     this.overridePassword = null;
     this.isPMBTACheckON = false;
     this.ispmbtaUploadBtn = false;

        }
      },
      error: (err) => {
        this.isUploading = false;
        this.uploadStatus = 'failed';
        this.uploadMessage = `${this.payload?.fileDetails.fileName} upload failed.`;
        this.upload.$uploadStatus.next({ type: 'upload_failed' })
        if (this.payload && this.multipartUploadModel) {
          this.upload.updateMultipartSummary(this.payload, this.multipartUploadModel, UploadSummaryStatus.FAILED);
        }
         this.upload.loggingService({ 
          userName: this.userId, 
          caseNumber: this.caseNumber, 
          fileName: this.payload?.fileDetails.fileName, 
          Message: "Error while completing MultipartUpload",
          error: JSON.stringify(err), 
          type: "error"
        });
      }
    })
  }

  private uploadSingleFile() {
    this.multipartUploadModel = null

    if (!this.payload || !this.singleUploadModel) {
      return
    }
    const startTime = this.util.today()
    this.upload.loggingService({
      userName: this.userId, 
      caseNumber: this.caseNumber, 
      fileName: this.payload!.fileDetails.fileName, 
      maskedFileName:this.singleUploadModel.maskedFileName,  
      Message: "Single file upload is initiated", 
      type: "info"
    });
    this.upload.updateSingleUploadSummary(this.payload, this.singleUploadModel, startTime)

    this.$uploadSubscription = this.upload.uploadFile(
      this.singleUploadModel.preSignedUrl,
      this.payload?.fileDetails.content,
      this.payload?.maskedFileName
    ).subscribe({
      next: (e: HttpEvent<any>) => {
        switch (e.type) {
          case HttpEventType.Sent:
            this.isUploading = true;
            this.uploadProgress = 0;
            break;
            case HttpEventType.UploadProgress:
              let percentage = Math.round((e.loaded / (e.total || 1)) * 100);
              this.uploadProgress = Math.min(percentage, 100);
              break;
          case HttpEventType.Response:
            this.isUploading = false;
            this.uploadProgress = 0;
            this.uploadStatus = 'success';
            this.uploadMessage = `${this.payload?.fileDetails.fileName} uploaded successfully.`;
            
            this.upload.$uploadStatus.next({ type: 'upload_success' })
            this.upload.updateSingleUploadSummary(this.payload, this.singleUploadModel, startTime, UploadSummaryStatus.COMPLETED,this.osVersion,this.panicMessage);
            this.upload.loggingService({
              userName: this.userId, 
              caseNumber: this.caseNumber, 
              fileName: this.payload?.fileDetails.fileName, 
              maskedFileName:this.singleUploadModel!.maskedFileName,  
              Message: "File uploaded successfully", 
              type: "info"
            });
            this.updatingCaseNote(
              this.caseNumber,
              this.payload!.fileDetails.fileName,
              this.payload!.fileType
            );
            this.caseNumber = '';
            this.isPMBTACheckON = false;
            this.ispmbtaUploadBtn = false;
            this.osVersion = '';
            this.panicMessage = '';
            this.fileType = '';
            this.unique_id = '';
            this.payload = null;
            this.singleUploadModel = null;
            this.overridePassword = null;
        }
      },
      error: (error) => {
        this.uploadStatus = 'failed'
        this.uploadMessage = `${this.payload?.fileDetails.fileName} upload failed.`;
        this.isUploading = false;
        this.uploadProgress = 0;
        this.upload.$uploadStatus.next({ type: 'upload_failed' })
        this.upload.updateSingleUploadSummary(this.payload, this.singleUploadModel, startTime, UploadSummaryStatus.FAILED)
        this.upload.loggingService({
          userName: this.userId, 
          caseNumber: this.caseNumber, 
          fileName: this.payload!.fileDetails.fileName, 
          maskedFileName:this.singleUploadModel!.maskedFileName,  
          Message: "single file upload failed" , 
          error: JSON.stringify(error),
          type: "error"
        });
      }
    })
  }
 
 onClosePopup() {
      this.showUploadFailurePopup = false;
      this.uploadFailurePopupInitialized = false;
  }
  handleFetchPreviousDetails() { 
    this.previousUploadCheck = false;   
    if (this.payload) {
      this.getPrevUploadDetails(this.payload); 
    }
  }

  interruptUpload(type: string): void {
    if (type === 'cancel') {
      this.upload.updateMultipartSummary(
        this.payload,
        this.multipartUploadModel,
        UploadSummaryStatus.CANCELLED
      );
      this.cancelUpload();

    } else if (type === 'pause') {
      this.upload.updateMultipartSummary(
        this.payload,
        this.multipartUploadModel,
        UploadSummaryStatus.PAUSED
      );
      this.pauseUpload();
      
    } else if (type === 'resume') {
      this.upload.loggingService({
        userName: this.userId, 
        caseNumber: this.caseNumber, 
        fileName: this.payload && this.payload.fileDetails ? this.payload.fileDetails.fileName : '',
        maskedFileName: this.multipartUploadModel && this.multipartUploadModel.multipartSas ? this.multipartUploadModel.multipartSas.maskedFileName : '',
        Message: " Multipart file upload is resumed.", 
        type: "info"
      });
      this.resumeUpload();
    }
  }

  private cancelUpload(): void {
    this.$uploadSubscription?.unsubscribe();

    if (this.multipartUploadModel !== null) {
      this.multipartUploadModel?.resetProgress();
      const param = {
        fileName: this.payload?.fileDetails.fileName,
        fileSize: this.payload?.fileDetails.content.size,
        caseNumber: this.payload?.caseNumber,
        uploadId: this.multipartUploadModel.multipartSas.uploadId,
        maskedFileName: this.multipartUploadModel.multipartSas.maskedFileName,
        fileType: this.payload?.fileType
      }
      // Store maskedFileName and uploadId before nulling the model
      const maskedFileName = this.multipartUploadModel.multipartSas.maskedFileName;
      const uploadId = this.multipartUploadModel.multipartSas.uploadId;
      this.upload.cancelMultipartsUpload(param).subscribe({
        next: () => {
          this.multipartUploadModel = null;
          this.uploadStatus = 'cancelled'
          this.uploadMessage = `${this.payload?.fileDetails.fileName} upload cancelled.`;
          this.isUploading = false
          this.upload.$uploadStatus.next({ type: 'upload_cancelled' })
          this.upload.loggingService({
            userName: this.userId, 
            caseNumber: this.caseNumber, 
            fileName: this.payload!.fileDetails.fileName, 
            maskedFileName: maskedFileName,  
            uploadId: uploadId,
            Message: "Multipart file upload is cancelled successfully",
            type: "info"
          });
          
        },
        error: (error) => {
          // Use stored maskedFileName and uploadId in error path too
          this.multipartUploadModel = null;
          this.upload.loggingService({
            userName: this.userId, 
            caseNumber: this.caseNumber, 
            fileName: this.payload!.fileDetails.fileName, 
            maskedFileName: maskedFileName,  
            uploadId: uploadId,
            Message: "Multipart file upload is cancelled failed",
            error: JSON.stringify(error),
            type: "error"});
        }
      })
    }
  }

  private pauseUpload(): void {
    this.$uploadSubscription?.unsubscribe();
    this.multipartUploadModel?.resetProgress(true);
    this.upload.loggingService({
      userName: this.userId, 
      caseNumber: this.caseNumber, 
      fileName: this.payload!.fileDetails.fileName, 
      maskedFileName:this.multipartUploadModel!.multipartSas.maskedFileName,  
      Message: " Multipart file upload is paused.", 
      type: "info"
    });
  }

  private resumeUpload(): void {
    this.upload.loggingService({
      userName: this.userId, 
      caseNumber: this.caseNumber, 
      fileName: this.payload!.fileDetails.fileName,
      maskedFileName:this.multipartUploadModel!.multipartSas.maskedFileName,  
      Message: "Multipart file upload is resumed.", 
      type: "info"
    });
    this.uploadMultipartsFile()
  }

  isSingleUpload(): boolean {
    return !this.payload?.fileDetails.hasMultiparts
  }

  ngOnDestroy(): void {
    this.$subscriptions.forEach(s => s.unsubscribe())
  }
// get previous upload details for multipart upload
  private getPrevUploadDetails(param: UploadParam) {
    this.upload.getPrevFileUploadDetails(param).subscribe({
      next: (res) => {
        this.upload.loggingService({
          userName: this.userId, 
          caseNumber: this.caseNumber, 
          fileName: param.fileDetails.fileName,  
          Message: "successfully received previous upload details for multipart file upload", 
          type: "info"
        });
        if (res) {
          this.prevUploadData = res;
          this.unique_id = this.prevUploadData.unique_id;
          
          if (this.payload) {
            this.payload.unique_id = this.unique_id;
          }
          if (this.prevUploadData.PartialUpload === 'Y') {
            this.showRadioButton = false;
            this.partialParts = true;
            this.failedParts = false; 
            this.showUploadFailurePopup = true;
            let percentage = Math.round(
                ((this.prevUploadData?.no_parts_uploaded || 0) /
                  (this.prevUploadData?.totalParts || 1)) *
                100
              );
              this.failedAtPercentage = Math.min(percentage, 100);
          } else {
            this.showRadioButton = false;
            if(param.fileType === 'Core'){
            this.checkForPmbtaMatched(param);
            }else{
            this.getBatchMutltipartPresignedUrls(param);
            }
          }
        }
      },
      error: (error) => {
        this.showRadioButton = false;
        this.upload.loggingService({
          userName: this.userId,
          caseNumber: this.caseNumber,
          fileName: param.fileDetails.fileName,
          Message: "Error while getting previous upload details for multipart file upload",
          error: JSON.stringify(error),
          type: "error"
        });
      },
    });
  }

  //resume functionality on reload or refresh or log off
  private initiateResumeUpload(param: UploadParam) {
    if (this.isResumeInitiated && this.payload !== null) {
      this.upload.loggingService({
        userName: this.userId,
        caseNumber: this.caseNumber,
        fileName: param.fileDetails.fileName,
        Message: "Resume upload initiated",
        type: "info"
      });
      // Create a full list of part numbers from 1 to totalParts
      let fullList = Array.from(
        { length: this.prevUploadData.totalParts },
        (_, i) => i + 1
      );
      let partNumberList = this.prevUploadData.Parts.map((part: any) => {
        return part.PartNumber;
      });
      // Find the missing part numbers by filtering the full list
      let newPartNumList = fullList.filter(
        (partNumber) => !partNumberList.includes(partNumber)
      );
      param.uploadId = this.prevUploadData.uploadId;
      param.unique_id = this.prevUploadData.unique_id;
      param.maskedFileName = this.prevUploadData.maskedFileName;
      param.osVersion = this.prevUploadData.osVersion;
      if (newPartNumList.length > 0) {
        const getpartData = this.util.getPartDetails(param.fileDetails.content.size)
        let batchSize = 2 * getpartData.batchSize;
        const totalParts = getpartData.totalParts;
        const numBatches = Math.ceil(totalParts / batchSize);
        const partNumList: any[] = [];
        for (let i = 0; i < numBatches; i++) {
          let batch = newPartNumList.slice(i * batchSize, (i + 1) * batchSize);
          partNumList.push(batch);
        }
        this.batchPrtnumlist = partNumList;

        if (partNumList.length > 0) {
          param.partNumberList = partNumList[0];

          this.upload.getSasUrls(param).subscribe({
            next: (sas: PreSignedUrlModel) => {
              sas.uploadSummary = this.prevUploadData;
              this.multipartUploadModel = new MultipartUploadProgress(sas, param, partNumList);
              this.upload.loggingService({
                userName: this.userId,
                caseNumber: this.caseNumber,
                fileName: param.fileDetails.fileName,
                maskedFileNam: this.prevUploadData.maskedFileName,
                Message: "Resume upload initiated",
                type: "info"
              });
              let percentage = Math.round(
                ((this.multipartUploadModel?.successCount || 0) /
                  (this.multipartUploadModel?.totalCount || 1)) *
                100
              );
              this.uploadProgress = Math.min(percentage, 100);
              this.uploadMultipartsFile();
            },
            error: (err) => {
              this.uploadStatus = 'presignedUrl_error';
              this.upload.$uploadStatus.next({ type: 'presigned_url_error' })
              this.upload.loggingService({
                userName: this.userId,
                caseNumber: this.caseNumber,
                fileName: param.fileDetails.fileName,
                maskedFileName: this.prevUploadData.maskedFileName,
                error: JSON.stringify(err),
                Message: "Error while getting Pre-signed url for resume upload",
                type: "error"
              });
            }
          })
        }
      } else {
        // if all parts are uploaded but failed to complete
        this.upload.loggingService({
          userName: this.userId,
          caseNumber: this.caseNumber,
          fileName: param.fileDetails.fileName,
          maskedFileName: this.prevUploadData.maskedFileName,
          Message: "All parts already uploaded, proceeding to complete multipart upload",
          type: "info"
        });
        
        let sas: PreSignedUrlModel = {
          totalParts: 0,
          uploadId: "",
          preSignedUrls: []
        }; // Initialize 'sas' variable with an empty object

        sas.uploadSummary = this.prevUploadData;
        sas.uploadId = this.prevUploadData.uploadId;
        sas.maskedFileName = this.prevUploadData.maskedFileName;
        sas.totalParts = this.prevUploadData.totalParts;
        this.multipartUploadModel = new MultipartUploadProgress(sas, this.payload, this.batchPrtnumlist);
        let percentage = Math.round(
          ((this.multipartUploadModel?.successCount || 0) /
            (this.multipartUploadModel?.totalCount || 1)) *
          100
        );

        this.uploadProgress = Math.min(percentage, 100);
        
        this.upload.loggingService({
          userName: this.userId,
          caseNumber: this.caseNumber,
          fileName: param.fileDetails.fileName,
          maskedFileName: this.prevUploadData.maskedFileName,
          uploadId: this.prevUploadData.uploadId,
          Message: `Calling markSuccess with ${this.multipartUploadModel.totalCount} parts at ${this.uploadProgress}% progress`,
          type: "info"
        });
        
        this.markSuccess(this.multipartUploadModel);
      }

    }
  }

  radioHandlerEvent(event: any) {
    this.radioButtonValue = event.target.value;

    if (this.radioButtonValue === 'fresh_upload') {
      if (this.isMultipartFailed) {
        this.isMultipartFailed = false
        this.partialParts = false; // Set the flag for partial parts message
        this.failedParts = false;
        this.progressMap = {};
        this.showUploadFailurePopup = false;
        this.$uploadSubscription?.unsubscribe();
        this.multipartUploadModel?.resetProgress(true);
      }
      this.isResumeInitiated = false;
      this.previousUploadCheck = false;
      if (this.payload) {
        this.getBatchMutltipartPresignedUrls(this.payload);
      }
      this.showRadioButton = false;
    } else {
       this.upload.loggingService({
      userName: this.userId,
      caseNumber: this.caseNumber,
      Message: "upload Failure Popup is opened and clicked on resume button for this case number:: ",
      type: "info"
      });
      this.isMultipartFailed = false;
      this.partialParts = false; // Set the flag for partial parts message
      this.failedParts = false;
      this.showUploadFailurePopup = false;
      this.isResumeInitiated = true;
      this.showRadioButton = false;
      if (this.payload) {
        this.initiateResumeUpload(this.payload);
      }
    }

    if (this.uploadProgressBlockElement) {
      this.uploadProgressBlockElement.nativeElement.style.display = 'block';
    }
  }

  // batch process implementation
  private getBatchMutltipartPresignedUrls(param: UploadParam) {
    this.upload.loggingService({
      userName: this.userId,
      caseNumber: this.caseNumber,
      fileName: param.fileDetails.fileName,
      Message: "Entering into getBatchMutltipartPresignedUrls() function, getting pre-signed url for multipart file upload",
      type: "info"
    });
    const getpartData = this.util.getPartDetails(param.fileDetails.content.size)
    let batchSize = 2 * getpartData.batchSize;
    const totalParts = getpartData.totalParts;
    const numBatches = Math.ceil(totalParts / batchSize);
    const partNumList: any[] = [];
    for (let i = 0; i < numBatches; i++) {
      const start = i * batchSize + 1;
      const end = Math.min(start + batchSize - 1, totalParts);
      const partList = Array.from(
        { length: end - start + 1 },
        (_, index) => start + index
      );
      partNumList.push(partList);
    }
    this.batchPrtnumlist = partNumList;
    if (partNumList.length > 0) {
      param.partNumberList = partNumList[0];

      this.upload.getSasUrls(param).subscribe({
        next: (sas: PreSignedUrlModel) => {
          this.multipartUploadModel = new MultipartUploadProgress(sas, param, partNumList);
          this.uploadMultipartsFile();
          this.upload.loggingService({
            userName: this.userId,
            caseNumber: this.caseNumber,
            fileName: param.fileDetails.fileName,
            maskedFileName: sas.preSignedUrls[0].maskedFileName,
            Message: "Successfully received pre-signed url for multipart file upload",
            type: "info"
          });
        },
        error: (err) => {
          this.uploadStatus = 'presignedUrl_error';
          this.upload.$uploadStatus.next({ type: 'presigned_url_error' })
          this.upload.loggingService({
            userName: this.userId,
            caseNumber: this.caseNumber,
            fileName: param.fileDetails.fileName,
            Message: "Error while getting Pre-signed url for multipart file upload",
            error: JSON.stringify(err),
            type: "error"
          });
        },
      });
    }
  }

  // this partial reading for determination of Core/Non-Core
  partialFile(file: any, partBegin: any, partEnd: any): Observable<any> {
    const reader = new FileReader();
    const slice = file.slice(partBegin, partEnd);
    reader.readAsArrayBuffer(slice);
    return Observable.create((observer: any) => {
      reader.onload = function (e) {
        // const blobAsFile = new File([reader.result], file.name, { type: file.type, lastModified: file.lastModifiedDate });
        const blobObj = new Blob([reader.result as BlobPart], { type: file.type });
        observer.next(blobObj);
      };
    });
  }

  // checking file type core / non-core
  checkUploadFileType(param: UploadParam): Observable<any> {
    let CORETOOL_FILE_PART_SIZE = "4096"
    return new Observable((observer) => {
      if (param.fileDetails.content == null) {
        return;
      }
      this.partialFile(
        param.fileDetails.content,
        0,
        CORETOOL_FILE_PART_SIZE
      ).subscribe(
        (data) => {
          const fd = new FormData();
          fd.append("file", data, param.fileDetails.fileName || '');
          fd.append("caseNumber", this.caseNumber,);
          fd.append("flSize", param.fileDetails.content.size.toString());
          this.upload.checkFileType(fd).subscribe(
            (response: any) => {
              console.log("File type response: ", response);
              this.fileType = response.fileType;
              observer.next(response);
            },
            (err) => {
              console.log("Error while checking file type");
              this.upload.loggingService({
                userName: this.userId,
                caseNumber: this.caseNumber,
                fileName: param.fileDetails.fileName,
                Message: "Error while calling checkFileType API",
                error: JSON.stringify(err),
                type: "error"
              });
            }
          );
        },
        (error) => {
          console.log("Error while checking file type");
          this.upload.loggingService({
            userName: this.userId,
            caseNumber: this.caseNumber,
            fileName: param.fileDetails.fileName,
            Message: "Error while checking file type",
            error: JSON.stringify(error),
            type: "error"
          });
        }
      );
    });
  }

  // validating core file for PMBTA details
  validateCoreforPMBTA(param: UploadParam): Observable<any> {
    let PMBTA_CORETOOL_FILE_PART_SIZE = "6291456"
    this.isPMBTACheckON = true;
    console.log("Validating PMBTA for file type: ", JSON.stringify(param.fileDetails));
    this.upload.loggingService({
      userName: this.userId,  
      caseNumber: this.caseNumber,
      fileName: param.fileDetails.fileName,
      Message: "Validating PMBTA for file type",
      type: "info"
    });
    // this.uploadSuccessMsg = this.config.UPLOAD_MSG_PMBTA_CHECK;
    // this.timeElapsed = { hours: "00", minutes: "00", seconds: "00" };
    const self = this;
    return new Observable(observer => {
      if (param.fileDetails.content == null) {
        return;
      }
      this.partialFile(
        param.fileDetails.content,
        0,
        PMBTA_CORETOOL_FILE_PART_SIZE
      ).subscribe(
        (data) => {
          const fd = new FormData();
          fd.append("file", data, param.fileDetails.fileName || '');
          fd.append("caseNumber", this.caseNumber,);
          fd.append("flSize", param.fileDetails.content.size.toString());
          this.spinner = true;
          this.upload.pmbtaCheck(fd).subscribe(
            (response: any) => {
              this.spinner = false;
              console.log("File type response: ", response);
              this.upload.loggingService({
                userName: this.userId,
                caseNumber: this.caseNumber,
                fileName: param.fileDetails.fileName,
                Message: "Successfully checked file type for PMBTA",
                type: "info"
              });
              // this.fileType = response.pmbtaResult.fileType;
              this.unique_id = response?.unique_id ? response?.unique_id :undefined;
              if(this.payload){
                this.payload = { ...this.payload, unique_id: this.unique_id }
              }
              // this.payload?this.payload?.unique_id = response.unique_id;
              observer.next(response);
            },
            (err) => {
              this.spinner = false;
              console.log("Error while checking file type");
              this.upload.loggingService({
                userName: this.userId,
                caseNumber: this.caseNumber,
                fileName: param.fileDetails.fileName,
                Message: "Error while checking file type for PMBTA",
                error: JSON.stringify(err),
                type: "error"
              });
        this.isUploading = false;
        this.uploadStatus = 'failed';
        this.uploadMessage = `${this.payload?.fileDetails.fileName} upload failed.`;
        this.upload.$uploadStatus.next({ type: 'upload_failed' })
        if (this.payload && this.multipartUploadModel) {
          this.upload.updateMultipartSummary(this.payload, this.multipartUploadModel, UploadSummaryStatus.FAILED);
        }else{
          const startTime = this.util.today()
        this.upload.updateSingleUploadSummary(this.payload, this.singleUploadModel, startTime, UploadSummaryStatus.FAILED)

        }
            }
          );
        },
        (error) => {
          this.spinner = false;
          console.log("Error while checking file type");
          this.upload.loggingService({
            userName: this.userId,
            caseNumber: this.caseNumber,
            fileName: param.fileDetails.fileName,
            Message: "Error while checking file type for PMBTA",
            error: JSON.stringify(error),
            type: "error"
          });
        this.isUploading = false;
        this.uploadStatus = 'failed';
        this.uploadMessage = `${this.payload?.fileDetails.fileName} upload failed.`;
        this.upload.$uploadStatus.next({ type: 'upload_failed' })
        if (this.payload && this.multipartUploadModel) {
          this.upload.updateMultipartSummary(this.payload, this.multipartUploadModel, UploadSummaryStatus.FAILED);
        }else{
          const startTime = this.util.today()
        this.upload.updateSingleUploadSummary(this.payload, this.singleUploadModel, startTime, UploadSummaryStatus.FAILED)

        }
        }
      );
    });
  }
  UploadOverrideFile() {
    if (this.overrideUpload) {
      if (this.overridePassword && this.overridePassword.length > 1) {
        this.upload.validatePMBTA(this.caseNumber).subscribe(
          (res: any) => {
            if (res !== undefined) {
              this.case_pwd = res.result;
            }
            if (this.case_pwd.toString() !== this.overridePassword) {
              alert("invalid override password");
            } else {

              this.isPMBTACheckON = false;
                if (this.payload) {
              this.afterFileSelected(this.payload)
              }
            }
          },
          (error: any) => {

            console.log("Error while checking file type");
            this.upload.loggingService({
              userName: this.userId,
              caseNumber: this.caseNumber,
              fileName: this.payload?.fileDetails.fileName,
              Message: "Error while validating PMBTA override password",
              error: JSON.stringify(error),
              type: "error"
            });
          }
        );
      } else {
        alert("Please enter valid password to proceed");
      }
    } else {
      alert(
        "Please select override option and enter password to continue upload."
      );
    }
  }
  updatingCaseNote(caseNo: any, fileName: any, fileType: any) {
    let param = {
      caseNumber: caseNo,
      fileName: fileName,
      fileType: fileType,
    }
    this.upload.updateCaseNotes
      (param)
      .subscribe((res) => {
        if (res !== undefined && res.status !== 400) {
          if (res.Case_Update_Status === "S") {

            this.upload.loggingService({
              userName: this.userId,
              caseNumber: this.caseNumber,
              fileName: fileName,
              Message: "Case Note update successful::" + JSON.stringify(res),
              type: "info"
            });
          } else {
            this.upload.loggingService({
              userName: this.userId,
              caseNumber: this.caseNumber,
              fileName: fileName,
              Message: "Case Note update returned invalid response.",
              type: "error"
            });
          }
        } else {
          this.upload.loggingService({
            userName: this.userId,
            caseNumber: this.caseNumber,
            fileName: fileName,
            Message: "Error updating Case Note.",
            type: "error"
          });
        }
      },
        (error) => {
          this.upload.loggingService({
            userName: this.userId,
            caseNumber: this.caseNumber,
            fileName: fileName,
            Message: "Error updating Case Note.",
            error: JSON.stringify(error),
            type: "error"
          });

        }
      );
  }
  updatePMBTACaseNote(caseNo: any, fileName: any, panicMsg: any) {
    let param = {
      caseNumber: caseNo,
      panicMsg: panicMsg
    }
    this.upload
      .updatePMBTANotes(param)
      .subscribe((res: any) => {
        if (res !== undefined && res.status !== 400) {
          if (res.Case_Update_Status === "S") {
            this.upload.loggingService({
              userName: this.userId,
              caseNumber: this.caseNumber,
              fileName: fileName,
              Message: "Case Note update for PMBTA results successful::" +
                JSON.stringify(res),
              type: "info"
            });
          } else {
            this.upload.loggingService({
              userName: this.userId,
              caseNumber: this.caseNumber,
              fileName: fileName,
              Message: "Error updating Case Note for PMBTA.",
              type: "error"
            });
          }
        } else {
          this.upload.loggingService({
            userName: this.userId,
            caseNumber: this.caseNumber,
            fileName: fileName,
            Message: "Case Note update for PMBTA check returned invalid response.",
            type: "error"
          });
        }
      },
        (error) => {
          this.upload.loggingService({
            userName: this.userId,
            caseNumber: this.caseNumber,
            fileName: fileName,
            Message: "Error updating Case Note for PMBTA.",
            error: JSON.stringify(error),
            type: "error"
          });

        }
      );
  }
  checkForPmbtaMatched(param: UploadParam){
    console.log("Checking PMBTA match for file: ", JSON.stringify(param));
    this.validateCoreforPMBTA(param).subscribe(
      (pmbtaRes) => {
        if (
          pmbtaRes !== undefined &&
          pmbtaRes.status === 400
        ) {
          this.upload.loggingService({
            userName: this.userId,
            caseNumber: this.caseNumber,
            fileName: param.fileDetails.fileName,
            fileSize: param.fileDetails.content.size,
            Message: "Received error during file type identification.",
            error: JSON.stringify(pmbtaRes),
            type: "error"
          });
        } else {
          const pmbtaResult = pmbtaRes.pmbtaResult;
          // process incoming PMBTA response and display messages accordingly
          let panicResult = pmbtaResult.panicResult;
            this.osVersion = pmbtaResult.osVersion;
            this.unique_id = pmbtaRes.unique_id; // Update component's unique_id with fresh response
            param.osVersion = pmbtaResult.osVersion;
            param.unique_id = pmbtaRes.unique_id;
            if(this.payload){
              this.payload = { ...this.payload, osVersion: pmbtaResult.osVersion ,unique_id: pmbtaRes.unique_id}
            }
            this.panicMessage = pmbtaResult.panicMessage;
            // Update singleUploadModel with fresh unique_id if it exists
            if (this.singleUploadModel) {
              this.singleUploadModel.unique_id = pmbtaRes.unique_id;
            }
            if(this.payload&& this.payload.fileDetails.hasMultiparts && this.multipartUploadModel){
            this.upload.updateMultipartSummary(this.payload, this.multipartUploadModel, UploadSummaryStatus.IN_PROGRESS);
            }else{
              const startTime = this.util.today()
            this.upload.updateSingleUploadSummary(this.payload, this.singleUploadModel, startTime, UploadSummaryStatus.IN_PROGRESS);
            }
          if (
            panicResult == "0" ||
            panicResult == "4" ||
            panicResult == "99"
          ) {
            this.isPMBTACheckON = true;
            this.pmbta_override = panicResult;
            this.afterFileSelected(param);
          } else {
            this.isBurtAvailable = true;
            this.ispmbtaUploadBtn = true;
            this.pmbta_override = panicResult;
            // if(this.isBurtAvailable) {
            let panicMessage = "";
            const panicErrorId = document.getElementById(
              "panicErrorMessage"
            );
            // panicErrorId.innerHTML = '';
            if (panicResult == 1) {
              this.panicErrorMessage =
                "NetApp Support Automation has identified a special action for the panic message " +
                "associated with the core file that you are trying to upload. " +
                pmbtaResult.extInstructions +
                " Your case owner will be able to help you further. If NetApp support personnel " +
                "request this core file, they will provide the override password to proceed with the core upload.";
              panicMessage =
                "NetApp Support Automation has identified a special action for the panic message " +
                "associated with the core file that you are trying to upload. " +
                pmbtaResult.extInstructions +
                " Your case owner will be able to help you further. If NetApp support personnel " +
                "request this core file, they will provide the override password to proceed with the core upload.";
            } else if (panicResult == 2) {
              this.panicErrorMessage =
                "Information from this file matches Bug ID: " +
                pmbtaResult.bugNumber +
                '. For more details, see: <a target="_blank" href="https://now.netapp.com/NOW/cgi-bin/bol?Type=Detail&Display=' +
                pmbtaResult.bugNumber +
                '">Bug Information</a>. If NetApp support personnel ' +
                "request this core file, they will provide the override password to proceed with the core upload.";
              panicMessage =
                "Information from this file matches Bug ID: " +
                pmbtaResult.bugNumber +
                ". For more details, see: https://now.netapp.com/NOW/cgi-bin/bol?Type=Detail&Display=" +
                pmbtaResult.bugNumber +
                " . If NetApp support personnel request this core file, they will provide " +
                "the override password to proceed with the core upload.";
            } else if (panicResult == 3) {
              this.panicErrorMessage =
                "Information from this file matches Bug ID: " +
                pmbtaResult.bugNumber +
                ". It is fixed in ONTAP release " +
                pmbtaResult.recRelease +
                " and later. For more details, see" +
                ' <a target="_blank" href="https://now.netapp.com/NOW/cgi-bin/bol?Type=Detail&Display=' +
                pmbtaResult.bugNumber +
                '">Bug Information</a>. If NetApp support personnel request this core file, ' +
                "they will provide the override password to proceed with the core upload.";
              panicMessage =
                "Information from this file matches Bug ID: " +
                pmbtaResult.bugNumber +
                ". It is fixed in ONTAP release " +
                pmbtaResult.recRelease +
                " and later. For more details, see: https://now.netapp.com/NOW/cgi-bin/bol?Type=Detail&Display=" +
                pmbtaResult.bugNumber +
                " . If NetApp support personnel request this core file, " +
                "they will provide the override password to proceed with the core upload.";
            }
            if (panicErrorId) {
              panicErrorId.innerHTML = this.panicErrorMessage;
            }
            // }
            // Invoke case note update with messages shown to user
            this.updatePMBTACaseNote(
              this.caseNumber,
              param.fileDetails.fileName,
              panicMessage
            );
          }
        }
      },
      (err) => {  this.upload.loggingService({
        userName: this.userId,
        caseNumber: this.caseNumber,
        fileName: param.fileDetails.fileName,
        fileSize: param.fileDetails.content.size,
        Message: "Error while getting Pre-signed url for single file upload",
        error: JSON.stringify(err),
        type: "error"
      }); }
    );
  }
  afterFileSelected(param: UploadParam) {
    if (param) {
      console.log("File selected: ", param);
      if (param.fileDetails.hasMultiparts) {
        this.getBatchMutltipartPresignedUrls(param);
        this.upload.loggingService({
          userName: this.userId,
          caseNumber: this.caseNumber,
          fileName: param.fileDetails.fileName,
          fileSize: param.fileDetails.content.size,
          Message: "Multipart file upload initiated",
          type: "info"
        });
      } else {
        // single file upload
        this.upload.loggingService({
          userName: this.userId,
          caseNumber: this.caseNumber,
          fileName: param.fileDetails.fileName,
          fileSize: param.fileDetails.content.size,
          Message: "Single file upload initiated",
          type: "info"
        });
        this.upload.getSasUrls(param).subscribe({
          next: (sas: PreSignedUrlModel) => {
            this.upload.loggingService({
              userName: this.userId,
              caseNumber: this.caseNumber,
              fileName: param.fileDetails.fileName,
              fileSize: param.fileDetails.content.size,
              maskedFileName: sas.preSignedUrls[0].maskedFileName,
              Message: "Successfully Received Pre-signed url for single file upload",
              type: "info"
            });
            this.singleUploadModel = sas.preSignedUrls[0]
            this.uploadSingleFile()
          },
          error: (err) => {
            this.uploadStatus = 'presignedUrl_error';
            this.upload.$uploadStatus.next({ type: 'presigned_url_error' })
            this.upload.loggingService({
              userName: this.userId,
              caseNumber: this.caseNumber,
              fileName: param.fileDetails.fileName,
              fileSize: param.fileDetails.content.size,
              Message: "Error while getting Pre-signed url for single file upload",
              error: JSON.stringify(err),
              type: "error"
            });
          }
        })
      }
    }

  }
}
